import { createRef, createElement, Component } from 'react';
import { node, bool } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import { b as navigationPropTypes, c as navigationDefaultProps } from '../chunk-18be6601.js';
import '../Navigation/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import '../Popover/index.js';
import _Menu from './styled.js';
import { withMenuContext } from './MenuContext.js';
export { default as MenuContext, MenuProvider, withMenuContext } from './MenuContext.js';
import MenuTrigger from './MenuTrigger.js';
import MenuButton from './MenuButton.js';
export { default as MenuButton, menuButtonDefaultProps, menuButtonPropTypes } from './MenuButton.js';
import MenuDivider from './MenuDivider.js';
export { default as MenuDivider } from './MenuDivider.js';
import MenuGroup from './MenuGroup.js';
export { default as MenuGroup, menuGroupDefaultProps, menuGroupPropTypes } from './MenuGroup.js';
import MenuItem from './MenuItem.js';
export { default as MenuItem, menuItemDefaultProps, menuItemPropTypes } from './MenuItem.js';
import MenuPopover from './MenuPopover.js';
export { default as MenuPopover, menuPopoverDefaultProps, menuPopoverPropTypes } from './MenuPopover.js';
var KEYS = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  HOME: 36,
  END: 35,
  FNUP: 33,
  FNDOWN: 34
};

var menuPropTypes = _objectSpread({}, navigationPropTypes, {
  children: node.isRequired,
  isHorizontal: bool
});

var menuDefaultProps = _objectSpread({}, navigationDefaultProps, {
  isHorizontal: false,
  role: 'menu',
  setInitialFocus: true
});

var Menu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Menu, _React$Component);

  function Menu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "menu", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeItemIndex: -1
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          context = _this$props.context,
          setInitialFocus = _this$props.setInitialFocus;
      var prevContext = prevProps.context;

      if (setInitialFocus && context && prevContext && context.isVisible !== prevContext.isVisible) {
        var menuItems = _this.menu.current && _this.menu.current.querySelectorAll('[role=menuitem]:not(:disabled)') || [];
        var startAtFirst = !context.startAt || context.startAt === 'first';
        requestAnimationFrame(function () {
          var focusedItem = menuItems[startAtFirst ? 0 : menuItems.length - 1];

          if (focusedItem) {
            // @ts-ignore
            focusedItem.focus();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var prevActiveItemIndex = _this.state.activeItemIndex;
      var menuItems = _this.menu.current && _this.menu.current.querySelectorAll('[role=menuitem]:not(:disabled)') || [];

      if (Object.values(KEYS).some(function (key) {
        return e.keyCode === key;
      })) {
        var activeItemIndex = prevActiveItemIndex;
        e.preventDefault();

        if (e.keyCode === KEYS.DOWN || e.keyCode === KEYS.RIGHT) {
          activeItemIndex = prevActiveItemIndex + 1;

          if (activeItemIndex >= menuItems.length) {
            activeItemIndex = 0;
          }
        } else if (e.keyCode === KEYS.UP || e.keyCode === KEYS.LEFT) {
          activeItemIndex = prevActiveItemIndex - 1;

          if (activeItemIndex < 0) {
            activeItemIndex = menuItems.length - 1;
          }
        } else if (e.keyCode === KEYS.HOME || e.keyCode === KEYS.FNUP) {
          activeItemIndex = 0;
        } else if (e.keyCode === KEYS.END || e.keyCode === KEYS.FNDOWN) {
          activeItemIndex = menuItems.length - 1;
        }

        if (activeItemIndex > -1 && menuItems[activeItemIndex]) {
          // @ts-ignore
          menuItems[activeItemIndex].focus();

          _this.setState({
            activeItemIndex: activeItemIndex
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var setInitialFocus = _this.props.setInitialFocus;
      var menuItems = _this.menu.current && _this.menu.current.querySelectorAll('[role=menuitem]') || [];
      var activeItemIndex = setInitialFocus ? 0 : -1; // @ts-ignore

      menuItems.forEach(function (item, i) {
        if (document.activeElement && document.activeElement.isEqualNode(item)) {
          activeItemIndex = i;
        }
      });

      _this.setState({
        activeItemIndex: activeItemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          isHorizontal = _this$props2.isHorizontal,
          props = _objectWithoutPropertiesLoose(_this$props2, ["children", "isHorizontal"]);

      return createElement(_Menu, _extends({
        elementRef: _this.menu,
        "aria-orientation": isHorizontal ? 'horizontal' : 'vertical',
        isHorizontal: isHorizontal,
        onKeyDown: _this.handleKeyDown,
        onFocus: _this.handleFocus
      }, props), children);
    });

    return _this;
  }

  return Menu;
}(Component); // @ts-ignore


_defineProperty(Menu, "propTypes", menuPropTypes);

_defineProperty(Menu, "defaultProps", menuDefaultProps);

var C = withMenuContext(Menu);
C.Button = MenuButton;
C.Divider = MenuDivider;
C.Group = MenuGroup;
C.Item = MenuItem;
C.Popover = MenuPopover;
C.Trigger = MenuTrigger;
export default C;
export { C as Menu, menuDefaultProps, menuPropTypes };